module.exports = __webpack_public_path__ + "static/media/parnter.48fad102.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_websitesec/parnter.png
// module id = 790
// module chunks = 0